<template>
  <div class="ui" :style="{ transform: `scale(${scale})` }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Ui',

  props: {
    scale: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="sass" scoped>
@font-face
  src: url('/assets/PICO-8.ttf')
  name: 'PICO-8'

.ui
  color: #fff
  width: 1920px * 0.1
  height: 1080px * 0.1
  overflow: hidden
  position: relative
  font-size: 4px
  background: #000000
  line-height: 5px
  user-select: none
  font-family: 'PICO-8'
  letter-spacing: 0px
  image-rendering: pixelated
</style>
